import { MalwareConfiguration } from "../../../@types/rldynamicanalysis/malwareconfiguration";

export const sortConfigurations = (configs: MalwareConfiguration) => {
  return configs.configurations.sort((a, b) => {
    const threatNameA = a["Threat name"] as string;
    const threatNameB = b["Threat name"] as string;
    return threatNameA.localeCompare(threatNameB);
  });
};

export const formatConfigurations = (
  configs: MalwareConfiguration["configurations"]
) => {
  const threatNamesCount = configs.reduce(
    (acc: Record<string, number>, data) => {
      const threatName = data["Threat name"] as string;
      return {
        ...acc,
        [threatName]: (acc[threatName] ?? 0) + 1
      };
    },
    {} as Record<string, number>
  ) as Record<string, number>;

  const threatNamesCounter: Record<string, number> = {};

  return configs.map(data => {
    const threatName = data["Threat name"] as string;
    const hasDuplicate = threatNamesCount[threatName] > 1;
    const currentPosition = (threatNamesCounter[threatName] ?? 0) + 1;
    threatNamesCounter[threatName] = currentPosition;
    return {
      title: `${threatName}${
        hasDuplicate
          ? ` [${currentPosition}/${threatNamesCount[threatName]}]`
          : ""
      }`,
      data
    };
  });
};

export const getMalwareConfigTabKey = (title: string) => `config-${title}`;
